import { useState, useCallback } from 'react';

export interface IStore<T extends object> {
  value: T;
  set: (newData: Partial<T>) => void;
}

export function Store<T extends object>(initialData: T): IStore<T> {
  const [value, setValue] = useState<T>(initialData);

  const set = useCallback((newData: Partial<T>) => {
    setValue((prevValue) => ({ ...prevValue, ...newData }));
  }, []);

  return {
    value,
    set
  };
}
